module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="p-hotels-locations p-search__direction-' +
((__t = ( this.options.bindingProperty )) == null ? '' : __t) +
' ' +
((__t = (classes )) == null ? '' : __t) +
'">\r\n	<input type="text" placeholder="' +
((__t = ( this.options.placeholder )) == null ? '' : __t) +
'" class="p-hotels-locations__input p-search__input p-search__direction-' +
((__t = ( this.options.bindingProperty )) == null ? '' : __t) +
'-input p-search__direction-' +
((__t = ( this.options.bindingProperty )) == null ? '' : __t) +
'__input">\r\n	<span class="p-search__direction-suggest"></span>\r\n</div>\r\n';

}
return __p
}